/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DescriptionField from '../Common/descriptionField';
import Attachments from '../Common/attachments';
import SelectField from '../Common/selectField';
import WorkerSelect from '../Common/workerSelect';
import OwnerSelect from '../Common/ownerSelect';
import AcceptanceCriteria from '../Criteria/acceptanceCriteria';
import { allows } from '../../utils/authorization';
import ProductSelect from '../Common/productSelect';
import {
  generateParentOptions,
  generateTeamOptions
} from '../../utils/resultModalHelpers';

class ResultDetailsTab extends React.Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    isFull: false,
    isCriteriaFull: false
  };

  toggleIsFull = () =>
    this.setState((prevState) => ({ isFull: !prevState.isFull }));

  toggleCriteriaFull = () =>
    this.setState((prevState) => ({
      isCriteriaFull: !prevState.isCriteriaFull
    }));

  render() {
    const {
      workPackage,
      criteria,
      attachmentList,
      product,
      team,
      parent,
      handleUpdate,
      onSelectChange,
      isTaskDetailOpen,
      parents,
      teams
    } = this.props;
    const { isFull, isCriteriaFull } = this.state;
    const allowEdit =
      workPackage.team_id || workPackage.product_id
        ? allows('update', workPackage)
        : true;

    const { teamOptions, selectedTeam } = generateTeamOptions(
      product.teams || teams,
      team
    );

    const { selectedParent, parentOptions } = generateParentOptions(
      parents,
      parent
    );

    return (
      <div className="details-tab">
        {!isCriteriaFull && (
          <div className={`row top-description ${isFull ? 'full' : ''}`}>
            <DescriptionField
              id={workPackage.id}
              type="WorkPackage"
              description={workPackage.description || ''}
              onFieldChange={handleUpdate}
              allowEdit={allowEdit}
              isFull={isFull}
              toggleIsFull={this.toggleIsFull}
            />
            {!isFull && (
              <div className="detail-tab-right selects-column">
                <ProductSelect
                  allowEdit={allowEdit}
                  onSelectChange={onSelectChange}
                  selectedTeam={selectedTeam}
                  selectedProductId={workPackage.product_id}
                />
                <SelectField
                  label="Team"
                  value={selectedTeam}
                  options={teamOptions}
                  allowEdit={allowEdit && teamOptions.length > 0}
                  handleChange={onSelectChange}
                  clearable={!!workPackage.product_id}
                />
                <WorkerSelect
                  label="Owner"
                  selectedWorker={{ id: workPackage.owner_id }}
                  allowEdit={allowEdit}
                  onUpdate={onSelectChange}
                  result={workPackage}
                />
                <OwnerSelect
                  label="Product Owner"
                  selectedOwner={{ id: workPackage.product_owner_id }}
                  allowEdit={allowEdit}
                  onUpdate={onSelectChange}
                  result={workPackage}
                />
                <SelectField
                  label="Parent"
                  value={selectedParent}
                  options={parentOptions}
                  allowEdit={allowEdit}
                  handleChange={onSelectChange}
                />
                {/* TODO: change false to allowEdit after implementation */}
              </div>
            )}
          </div>
        )}
        {!isFull && (
          <div className="row bottom-ac">
            <div className="ac-container">
              <AcceptanceCriteria
                addCriteria={this.props.addCriteria}
                removeCriteria={this.props.removeCriteria}
                workPackage={workPackage}
                isNew={!workPackage.id}
                criteria={criteria}
                isCriteriaFull={isCriteriaFull}
                toggleCriteriaFull={this.toggleCriteriaFull}
                detailCard
              />
            </div>
            {!isTaskDetailOpen && !isCriteriaFull && (
              <Attachments
                itemId={workPackage.id}
                type="workPackage"
                allowCreate={allows('create_attachments', workPackage)}
                allowDelete={allows('destroy_attachments', workPackage)}
                attachmentList={attachmentList}
                addAttachment={this.props.addAttachment}
                removeAttachment={this.props.removeAttachment}
                isNew={!workPackage.id}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

ResultDetailsTab.propTypes = {
  workPackage: PropTypes.object.isRequired,
  handleUpdate: PropTypes.func
};

const mapStateToProps = (state) => {
  return {
    teams: state.teamReducer.teams.filter((t) => !t.deleted_at)
  };
};

export default connect(mapStateToProps)(ResultDetailsTab);
